// extracted by extract-css-chunks-webpack-plugin
module.exports = {"explanation":"task-email-revise__explanation--15jNg"};